module.exports = __webpack_public_path__ + "static/media/administration_accounts_add.c1f5437a.svg";